import type { MouseEvent } from 'react';

/**
 * True when the browser's own link handling should win over an in-app click
 * handler: a modifier click opens the href in a new tab or window (or starts a
 * download), and a non-primary button is not a plain activation.
 *
 * Any handler that hijacks an anchor for SPA navigation has to bail out on
 * these before calling `preventDefault`, otherwise the anchor stops behaving
 * like a link and "open in new tab" silently navigates the current one instead.
 */
export const isModifiedClick = (event: MouseEvent<HTMLAnchorElement>): boolean =>
	event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
